/**
 * creates a disposable object then cleans it up after inner has resolved.
 * @param disposableObjectFactory
 * @param inner
 */
export default function usingAsync(disposableObjectFactory, inner) {
    return new Promise((resolve, reject) => {
        let disposableObject;
        try {
            const dO = disposableObject = disposableObjectFactory();
            inner(dO)
                .then(result => {
                dO.dispose();
                resolve(result);
            })
                .catch(error => {
                dO.dispose();
                reject(error);
            });
        }
        catch (error) {
            if (disposableObject) {
                disposableObject.dispose();
            }
            reject(error);
        }
    });
}
